import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navigation() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [currentHash, setCurrentHash] = useState(window.location.hash);
  useEffect(() => {
    const onHashChange = () => setCurrentHash(window.location.hash);
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);
  const navLinks = [{
    name: 'My Story',
    href: '#/my-story'
  }, {
    name: 'Services',
    href: '#/services'
  }, {
    name: 'Results',
    href: '#/results'
  }, {
    name: 'Resources',
    href: '#/resources'
  }, {
    name: 'Contact',
    href: '#/contact'
  }];
  const isActive = (href: string) => {
    if (href === '#/' && (currentHash === '' || currentHash === '#' || currentHash === '#/')) return true;
    return currentHash === href || currentHash.startsWith(`${href}/`);
  };
  return <nav className="sticky top-0 z-50 w-full bg-white border-b border-gray-100" data-id="element-126" data-mp="dhsfv9ud0bvx">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-127" data-mp="hhkp7orkum2c">
        <div className="flex justify-between items-center h-20" data-id="element-128" data-mp="mg4aro29dvu6">
          {/* Logo — links to homepage */}
          <div className="flex-shrink-0 flex items-center" data-id="element-129" data-mp="rgi8ac68hndy">
            <a href="#/" aria-label="Break a Pencil — Home" data-id="element-130" data-mp="wejs4zbhhqqh">
              <img src="https://cdn.magicpatterns.com/uploads/vCF4Tq5q2LXPwn1U5DnYip/Pencil--jpeg.jpg" alt="Break a Pencil Consulting" className="h-20 w-auto object-contain" data-id="element-131" data-mp="webev6bg8jer" />
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-132" data-mp="1a56poo5idakz">
            <div className="flex space-x-6" data-id="element-133" data-mp="1f6472yip20lf">
              {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-medium transition-colors border-b-2 pb-0.5 ${isActive(link.href) ? 'text-brand-orange border-brand-orange' : 'text-brand-gray-light border-transparent hover:text-brand-orange'}`} data-id="element-134" data-mp="1k3ctxcesest0">
                  {link.name}
                </a>)}
            </div>
            <a href="#/contact/book" className="inline-flex items-center justify-center px-6 py-2.5 border border-transparent text-sm font-bold rounded bg-brand-orange text-white hover:bg-brand-orange-hover transition-colors" data-id="element-135" data-mp="ze23fyl7lx7s">
              Book a Call
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="flex items-center md:hidden" data-id="element-136" data-mp="1i5ump1ah842b">
            <button type="button" className="inline-flex items-center justify-center p-2 rounded-md text-brand-gray-light hover:text-brand-navy hover:bg-gray-100 focus:outline-none" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-expanded="false" data-id="element-137" data-mp="1i64hd26guzec">
              <span className="sr-only" data-id="element-138" data-mp="1zh9pm8ovus8o">Open main menu</span>
              {isMobileMenuOpen ? <XIcon className="block h-6 w-6" aria-hidden="true" data-id="element-139" data-mp="24ftdwfqy8g47" /> : <MenuIcon className="block h-6 w-6" aria-hidden="true" data-id="element-140" data-mp="1pn9mgcd5vx2l" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isMobileMenuOpen && <div className="md:hidden bg-white border-b border-gray-100 shadow-lg absolute w-full" data-id="element-141" data-mp="1gqs8l1dexl35">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-142" data-mp="1knoc75sjk2ak">
            {navLinks.map(link => <a key={link.name} href={link.href} className={`block px-3 py-2 rounded-md text-base font-medium transition-colors ${isActive(link.href) ? 'text-brand-orange bg-brand-orange/5' : 'text-brand-gray-light hover:text-brand-orange hover:bg-gray-50'}`} data-id="element-143" data-mp="16skv4sic1l5w">
                {link.name}
              </a>)}
            <div className="pt-4 pb-2 px-3" data-id="element-144" data-mp="15z07pme4mw0k">
              <a href="#/contact/book" className="block w-full text-center px-4 py-3 border border-transparent text-base font-bold rounded bg-brand-orange text-white hover:bg-brand-orange-hover" data-id="element-145" data-mp="111rorjl5mny9">
                Book a Call
              </a>
            </div>
          </div>
        </div>}
    </nav>;
}